import { inject, Injectable, signal } from '@angular/core';
import { AppCurrencies } from '../state/app/app.reducer';
import { AppCurrenciesDto, AppService } from '../services/api.services';
import { untracked } from '@angular/core/primitives/signals';
import { operation } from '../pbir/utils/operation';
import { catchAppError } from '../shared/utils';
import { finalize, of, ReplaySubject, shareReplay, Subject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppCurrencyService {
  readonly appService = inject(AppService);
  
  private readonly _currencies$ = new ReplaySubject<AppCurrencies>(1);
  get currencies$() {
    this.ensureLoaded();
    return this._currencies$;
  }

  private readonly _currencies = signal<AppCurrencies>(null);
  get currencies() {
    this.ensureLoaded();
    return this._currencies;
  }

  readonly loading = signal(false);
  readonly loaded = signal(false);

  load() {
    this.ensureLoaded();
    return this.currencies$;
  }

  ensureLoaded() {
    untracked(() => {
      if (this.loaded() || this.loading())
        return;

      this.loading.set(true);
      this.loaded.set(false);

      this.appService.getCurrencies().pipe(
        catchAppError(() => of(<AppCurrenciesDto>{
          baseCurrencyCode: 'USD',
          currencies: [{
            currencyCode: 'USD',
            currencyName: 'USD'
          }]
        })),
        tap((dto: AppCurrenciesDto) => {
          let currencies = new AppCurrencies(
            dto.baseCurrencyCode,
            dto.currencies
          );

          this.currencies$.next(currencies);
          this.currencies.set(currencies);

          this.loaded.set(true);
          this.loading.set(false);
        }),
        finalize(() => this.loading.set(false))
      ).subscribe();
    });
  }
}
